import React, {
  FC,
  useCallback,
  useEffect,
  useState,
} from 'react'
import styled from 'styled-components'

import ArrowRight from '@Assets/SVG/ArrowRigh2T'
import { SVGIcon } from '@Components/Icons'
import { useMParticle } from '@Globals/MParticle/useMParticle'
import { useGroupVisibility } from '@Globals/ScrollPosition'

interface StyledBackToTopProps {
  show: boolean
}

const StyledBackToTop = styled.div<StyledBackToTopProps>`
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity .25s ease;
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 46px;
  height: 46px;
  z-index: ${({ theme }) => theme.zIndexes.backToTop};
  background-color: rgba(51, 51, 51, 0.85);
  cursor: pointer;
`

const StyledIcon = styled.div`
  transform: rotate(-90deg);
`

interface BackToTopButtonProps {
  onClick: () => void
  show: boolean
}

export const BackToTopButton: FC<BackToTopButtonProps> = ({ onClick, show }) => {
  const [shouldRender, setShouldRender] = useState(show)
  const [shouldShow, setShouldShow] = useState(show)

  useEffect(() => {
    if (show) {
      setShouldRender(true)

      const timeout = requestAnimationFrame(() => {
        setShouldShow(true)
      })

      return () => cancelAnimationFrame(timeout)
    }

    setShouldShow(false)

    return undefined
  }, [show])

  const onTransitionEnd = useCallback(() => {
    setShouldRender(false)
  }, [])

  if (!shouldRender) {
    return null
  }

  return (
    <StyledBackToTop
      onClick={onClick}
      onTransitionEnd={!shouldShow ? onTransitionEnd : undefined}
      show={shouldShow}
    >
      <StyledIcon>
        <SVGIcon color="white" icon={ArrowRight} />
      </StyledIcon>
    </StyledBackToTop>
  )
}

// TODO: On mobile cookie bar covers button

export const BackToTop: FC = () => {
  const headerIsVisible = useGroupVisibility('header') ?? true
  const footerIsVisible = useGroupVisibility('footer') ?? false
  const { otherEvent } = useMParticle()

  const onClick = useCallback(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
    otherEvent({
      eventName: 'go_to_top',
      attributes: {},
    })
  }, [otherEvent])

  return (
    <BackToTopButton
      onClick={onClick}
      show={!headerIsVisible && !footerIsVisible}
    />
  )
}
